import { createContext } from "react";

const RefContext = createContext();

export default RefContext;